<main class="container auction-details">
  @if (!isAuctionDetailsLoading && auction) {
    <header class="auction-details__header">
      <div class="auction-details__header-main">
        <pwj-breadcrumbs [breadcrumbsData]="breadcrumbsData"></pwj-breadcrumbs>

        <div class="auction-details__badges">
          <span
            class="auction-details__badge auction-details__badge--live"
            [class.auction-details__badge--future]="
              auction?.state === auctionStates.In_The_Future
            "
            [class.auction-details__badge--expired]="
              auction?.state === auctionStates.Expired
            ">
            <span class="auction-details__badge-dot"></span>
            {{ stateLabelKey | translate }}
          </span>
        </div>
      </div>

      <div class="auction-details__actions">
        <pwj-options-menu
          [menuOptions]="menuOptions"
          [isRowMode]="true"></pwj-options-menu>
      </div>
    </header>

    <section class="auction-details__layout">
      <div class="auction-details__media-column">
        <div class="auction-details__media-row">
          <div class="auction-details__gallery-column">
            <div class="auction-details__gallery-wrap">
              @if (auction?.product?.specialist_verified) {
                <span class="auction-details__verified-badge">
                  <i class="iconsax" icon-name="shield-tick"></i>
                  {{ 'auctions.verifiedProductModel' | translate }}
                </span>
              }

              <pwj-gallery
                [mediaData]="auction?.media || []"
                [mediaListCount]="4"
                [isColumnListMode]="true"
                previewWidth="800"
                previewHeight="600"
                previewWidthClass="!max-w-full"
                previewHeightClass="!max-h-full"
                listImgWidth="56"
                listImgHeight="56"
                listImgWidthClass="!w-56"
                listImgHeightClass="!h-56"
                [previewAlt]="
                  (auction?.title | translateData) || 'auction'
                "></pwj-gallery>
            </div>

            <pwj-auction-lot-info [auction]="auction"></pwj-auction-lot-info>
          </div>

          <div class="auction-details__meta-grid">
            <pwj-auction-meta-card
              label="auctions.productCode"
              [value]="'#' + (auction?.code || auction?.product?.code || '-')">
            </pwj-auction-meta-card>
            <pwj-auction-meta-card
              label="auctions.structureCode"
              [value]="'#' + (auction?.product_code || auction?.product?.code || '-')">
            </pwj-auction-meta-card>
            <pwj-auction-meta-card
              label="global.status"
              [value]="(statusLabelKey | translate) || '-'"
              valueClass="auction-details__status-active">
            </pwj-auction-meta-card>
          </div>
        </div>
      </div>

      <aside class="auction-details__sidebar">
        <pwj-auction-bid-panel
          [auction]="auction"
          [auctionId]="_auctionId"
          [isActive]="auction?.state === auctionStates.Active">
        </pwj-auction-bid-panel>

        <pwj-auction-support-card></pwj-auction-support-card>
      </aside>
    </section>

    <pwj-auction-terms-section [auction]="auction"></pwj-auction-terms-section>
  } @else {
    <pwj-auctions-detail-skeleton></pwj-auctions-detail-skeleton>
  }
</main>
